import InsurersHome from './InsurersHome';

export default InsurersHome;
